import Vue from 'vue';
import store from 'store/mainStore';
import 'es6-promise/auto';
import utils from 'js/services/utils';
import 'quasar/dist/quasar.umd.min';

Vue.use(utils);

(function(wv, undefined){
	wv.store = store;
	wv.contact = new Vue({
		el: "#contactWrapper",
		store,
		components: {
			'contact-main': () => import(/* webpackPrefetch: true */ 'components/contact/contactMain'),
		},
	});
}( window.wv = window.wv || {} ));